<template>
  <div
    class="product-card__marking"
  >
    <div
      itemscope itemtype="http://schema.org/Product"
    >
      <h2 itemprop="name">{{ pageTitle }}</h2>
      <div itemtype="http://schema.org/AggregateOffer" itemscope itemprop="offers">
        <!--      itemscope=""-->
        <div>{{ collectionQuantity }} товаров</div>
        <meta :content="`${collectionQuantity}`" itemprop="offerCount">
        <div>от {{ minPrice }} руб.</div>
        <meta :content="`${minPrice}`" itemprop="lowPrice">
        <!--        <div>до МАКС_ЦЕНА  руб.</div>-->
        <!--        <meta content="МАКС_ЦЕНА" itemprop="highPrice">-->
        <meta content="RUB" itemprop="priceCurrency">
        <img :src="`${productImage(String(product.imageId))}`" itemprop="image" :alt="product?.name || ''">
      </div>
      <div itemtype="http://schema.org/AggregateRating" itemprop="aggregateRating" itemscope>
        <!--      <span itemprop="itemReviewed">{{ product.name }}</span>-->
        <span itemprop="ratingValue">{{ product?.rating || '5' }}</span>
        <meta itemprop="bestRating" content="5"/>
        <meta itemprop="worstRating" content="0"/>
        <span itemprop="ratingCount">{{ randomNumberRatingCount }}</span>
        <span itemprop="reviewCount">{{ randomNumberReviewsCount }}</span>
      </div>
    </div>
  </div>

</template>

<script setup lang="ts">
import type { IProduct } from '#sitis/internal/controllers/products/models/Product';
import type { IWishlistItem } from '#sitis/internal/controllers/wish/models/WishlistItem';

const props = defineProps<{
  product: IProduct | IWishlistItem;
}>()
const $route = useRoute();
const productImage = useImage();

const pageTitle = computed(() => {
  return props.product?.name
})
const collectionQuantity = computed(() => {
  return props.product.quantity
})
const minPrice = computed(() => {
  return props.product.price
})

// Детерминированное значение на основе ID продукта для избежания ошибок гидратации
const randomNumberReviewsCount: any = computed(() => {
  const productId = String(props.product?.id || '0')
  // Простая хеш-функция для генерации детерминированного значения
  let hash = 0
  for (let i = 0; i < productId.length; i++) {
    hash = ((hash << 5) - hash) + productId.charCodeAt(i)
    hash = hash & hash // Convert to 32bit integer
  }
  const min = 200
  const max = 500
  return min + (Math.abs(hash) % (max - min + 1))
})
const randomNumberRatingCount: any = computed(() => {
  return randomNumberReviewsCount.value + 15
})
</script>

<style scoped lang="scss">
.product-card__marking {
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  opacity: 0;
}
</style>
